import { render, staticRenderFns } from "./StructureFilter.vue?vue&type=template&id=477caf84&"
import script from "./StructureFilter.vue?vue&type=script&lang=js&"
export * from "./StructureFilter.vue?vue&type=script&lang=js&"
import style0 from "./StructureFilter.vue?vue&type=style&index=0&id=477caf84&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports